import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { WorkflowStateTypes } from '../../system/workflows/model/workflow-state-types.model';

@Component({
    selector: 'dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
    @Input() label: string = '';
    @Input() isMultiple: boolean = false;

    @Input() path: string = '';
    @Input() objects: any[] = [];

    @Input('reset') reset: boolean;
    @Output() output = new EventEmitter<any[]>();

    @Input() chosenWorkflowState: WorkflowStateTypes[] = [];
    @Output() chosenWorkflowStateChange: EventEmitter<WorkflowStateTypes[]> = new EventEmitter<WorkflowStateTypes[]>();

    form: UntypedFormGroup;
    @ViewChild(MatSelect) matSelect: MatSelect;

    constructor(private fb: UntypedFormBuilder) {
        this.form = this.fb.group({
            select: ['']
        });
    }

    ngOnInit(): void {
        this.select.valueChanges.subscribe((objects: any[]) => {
            this.output.emit(objects);
        });
        //this.chosenWorkflowStateChange.emit(this.chosenWorkflowState)
    }

    ngOnChanges(): void {
        if (this.reset) {
            this.resetFunction();
        }
    }

    get select(): AbstractControl {
        return this.form.get('select')!;
    }

    display(obj: any): string {
        if (!obj || !this.path) {
            return '';
        }

        const value = this.path.split('.').reduce((current, property) => current?.[property], obj);

        return value?.toString() ?? '';
    }

    selectAll() {
        if (this.isMultiple) {
            this.select.patchValue(this.objects);
        }
    }

    deSelectAll() {
        this.reset = false;
        this.select.patchValue([]);

        if (!this.isMultiple) {
            this.close();
        }
    }

    close() {
        this.matSelect.close();
    }

    resetFunction() {
        this.select.setValue([]);
        this.output.emit([]);
        this.reset = false;
    }

    /*countSelections() {
      let selections = '';
      for (var propertyName in this.dropdownDefinition) {
        selections += (this.dropdownDefinition[propertyName].ENABLE && !this.dropdownDefinition[propertyName].DISABLED ? 'true' : 'false');
      }
    }*/
}
